export const getCostPerOne = (firstNumber, ratio, dollars, mainTokenName, secondaryTokenName) => {
    var secondNumber = firstNumber * ratio;

    const result = String(secondNumber).length > 10 ? String(secondNumber).slice(0,10) : secondNumber
    const resultDollars = String(dollars).length > 10 ? String(dollars).slice(0,10) : dollars


    return `1 ${mainTokenName} = ${result} (${resultDollars})`;
}